// Delivery-status workflow: the single source of truth for order fulfillment state
// (the legacy Order.status field has been retired — see OrderDetail.js / TasksPage.js).
// Sequential by default, but moving backward is allowed (corrections).
export const DELIVERY_STATUS_OPTIONS = [
    { value: 'preparing', badgeClass: 'secondary' },
    { value: 'ready_to_deliver', badgeClass: 'info' },
    { value: 'out_for_delivery', badgeClass: 'primary' },
    { value: 'delivered', badgeClass: 'success' },
    { value: 'cancelled', badgeClass: 'danger' },
];

// Statuses for which the UI offers an optional "send confirmation email" checkbox.
export const DELIVERY_STATUS_EMAIL_ELIGIBLE = ['ready_to_deliver', 'out_for_delivery', 'delivered'];

// Statuses whose confirmation-email step also requires an expected delivery date
// (see DeliveryStatusEmailModal.js) — currently just the one, but kept as an array in
// case a future status needs the same date-capture step.
export const DELIVERY_STATUS_REQUIRES_DATE = ['ready_to_deliver'];

// The three fixed delivery time windows. The keys and hours are defined ONCE, in the backend (services/delivery_windows.py) and served by
// GET /api/delivery-windows; this list is only the fallback used while that request is pending or if it fails.
export const DELIVERY_WINDOWS_FALLBACK = [
    { key: 'morning', start: '09:00', end: '12:00' },
    { key: 'afternoon', start: '12:00', end: '16:00' },
    { key: 'evening', start: '17:00', end: '21:00' },
];

export function getDeliveryStatusBadgeClass(status) {
    return DELIVERY_STATUS_OPTIONS.find((s) => s.value === status)?.badgeClass || 'secondary';
}
